// extracted by mini-css-extract-plugin
module.exports = {"home-heading":"hnVjAOyw","homeHeading":"hnVjAOyw","more":"_3wio-S9v","link-back":"_1lzdHSVB","linkBack":"_1lzdHSVB"};